import { Component, inject, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { BuscadorCliente } from '../buscador-cliente/buscador-cliente';
import { ETipoDocumentoSUNAT } from '@core/enums/tipoDocumentoSUNAT.enum';
import { form, required } from '@angular/forms/signals';
import { IClienteData } from '@core/interfaces/entidades/cliente.entidad';
import { UiButton } from '@shared/components/ui';
import { ToastService } from '@shared/services/toast.service';
import { IEmitirComprobanteComponent } from '@core/interfaces/components/emitirComprobante.component.interface';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { EmpresaService } from '@shared/services/empresa.service';
import { ETipoSistemasEmpresa } from '@core/enums/tipoSistemasEmpresa.enum';

@Component({
  selector: 'app-emitir-comprobante',
  imports: [BuscadorCliente, UiButton],
  templateUrl: './emitir-comprobante.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './emitir-comprobante.css',
})
export class EmitirComprobante {
  private toastService = inject(ToastService);
  private localStorageService = inject(LocalStorageService);
  private empresaService = inject(EmpresaService);

  showCliente = input.required<boolean>();
  tipo_documentos = Object.values(ETipoDocumentoSUNAT).filter(
    (tipo) => {
      if (
        (tipo === ETipoDocumentoSUNAT.FACTURA || tipo === ETipoDocumentoSUNAT.BOLETA) &&
        !this.empresaService.getEmpresaData()?.sistemas_activos?.includes(ETipoSistemasEmpresa.FACTURACION)
      ) {
        return false;
      }
      return true;
    },
  );
  formProcesarVenta = form(
    signal({
      tipo_documento:
        this.localStorageService.getUltimoTipoDocumentoSUNAT() || ETipoDocumentoSUNAT.NOTA_VENTA,
      cliente: null as IClienteData | null,
    }),
    (x) => {
      required(x.tipo_documento, { message: 'El tipo de documento es obligatorio' });
    },
  );

  selectTipoDocumento(tipo_documento: ETipoDocumentoSUNAT) {
    this.formProcesarVenta().controlValue().tipo_documento = tipo_documento;
    this.localStorageService.setUltimoTipoDocumentoSUNAT(tipo_documento);
  }
  emitir = output<IEmitirComprobanteComponent>();
  emitirComprobante() {
    if (this.formProcesarVenta().invalid()) {
      this.toastService.show(
        'top-right',
        'error',
        'Error',
        'Por favor complete los campos obligatorios',
      );
      return;
    }
    if (this.showCliente() && !this.formProcesarVenta().value().cliente) {
      this.toastService.show('top-right', 'error', 'Error', 'Por favor seleccione un cliente');
      return;
    }
    this.emitir.emit({
      tipo_documento: this.formProcesarVenta().value().tipo_documento,
      cliente: this.formProcesarVenta().value().cliente,
    });
  }
}
